import React from 'react';
import { ClassNameInterface } from '../../interfaces';

export const Card: React.FC<ClassNameInterface> = ({ children, className }) => (
  <div className={`card h-100 rounded-0 ${className || ''}`}>{children}</div>
);
